export default async function(path: string) {
    return await useAsyncData(path, () => {
        return $fetch(
            useRuntimeConfig().public.apiBaseUrl
            + `/api/${path}`
        );
    });
}